export default function ArrowRightIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="arrow-right"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="M22.6 38.85q-.55-.55-.55-1.375t.55-1.425L32.7 26H9.65q-.85 0-1.4-.575Q7.7 24.85 7.7 24q0-.85.55-1.425Q8.8 22 9.65 22H32.7L22.6 11.9q-.55-.55-.55-1.4 0-.85.55-1.4.6-.55 1.425-.55.825 0 1.375.55l13.55 13.5q.3.3.45.65.15.35.15.75 0 .35-.15.725t-.45.675L25.4 38.9q-.55.6-1.375.55-.825-.05-1.425-.6Z"
      />
    </svg>
  );
}
